import React, {useCallback, useEffect, useState} from "react"
import {generateStockUnitLabel} from "../../../utils/orderReception"
import moment from "moment/moment"
import DataGrid from "../../../components/DataGrid/DataGrid"

const OrderReceptionLots = (props) => {
	const {
		lots,
		orderOsiIds
	} = props

	const [data, setData] = useState([])

	useEffect(() => {
		createDataObject()
	}, [lots])

	const createDataObject = useCallback(() => {
		lots && setData(lots.map(createData))
	})

	const resolveOrderSupplierItem = (lot) => {
		const osi = lot.orderSupplierItem
		if (!osi) return {}
		// If it's a full OrderSupplierItem (has a nested supplierItem), use that
		if (osi.supplierItem) return osi.supplierItem
		// Otherwise it's already the supplierItem directly
		return osi
	}

	const createData = (lot) => {
		const allReceptionEvents = (lot.events || []).filter(e => e.mode === "RECEPTION")
		const osiIdSet = orderOsiIds?.length ? new Set(orderOsiIds) : null
		const receptionEvents = osiIdSet
			? allReceptionEvents.filter(e => osiIdSet.has(e.orderSupplierItem?.objectId))
			: allReceptionEvents
		const isUpdated = receptionEvents.some(e => e.receptionNumber != null)
		const receptionQty = receptionEvents.reduce((sum, e) => sum + (e.quantity || 0), 0) || lot.initialQuantity
		const supplierItem = resolveOrderSupplierItem(lot)
		return {
			name: supplierItem.name || "",
			reference: supplierItem.reference || "",
			lotNumber: lot ? lot.lotNumber : "",
			dlc: lot.dlc ? moment(lot.dlc).format("DD/MM/YYYY") : "",
			quantity: (receptionQty != null ? receptionQty.toString() : "") + "-" + (supplierItem ? generateStockUnitLabel(supplierItem) : ""),
			status: isUpdated ? "Incrémenté" : "Créé",
		}
	}

	const columns = [
		{
			key: "name",
			label: "Nom de l'article",
			dataType: "text",
			sortable: false,
			filter: {
				filterable: true,
				type: "text"
			}
		},
		{
			key: "reference",
			label: "Référence",
			dataType: "text",
			sortable: false,
			filter: {
				filterable: true,
				type: "text"
			}
		},
		{
			key: "lotNumber",
			label: "N° de lot",
			dataType: "text",
			sortable: false,
			filter: {
				filterable: true,
				type: "text"
			}
		},
		{
			key: "dlc",
			label: "DLC",
			dataType: "date",
			sortable: false,
			filter: {
				filterable: true,
				type: "date",
				strict: true
			}
		},
		{
			key: "quantity",
			label: "Quantité réceptionnée",
			dataType: "text",
			sortable: false,
			filter: {
				filterable: false,
			},
			render: (value) => {
				const quantity = value.split("-")[0]
				const unit = value.split("-")[1]
				return (
					<div><span>{quantity}</span><span style={{color: "#7C7C7C"}}> ({unit})</span></div>
				)
			}
		},
		{
			key: "status",
			label: "Statut",
			dataType: "text",
			sortable: false,
			filter: {
				filterable: false,
			},
			render: (value) => (
				<span style={{ color: value === "Mis à jour" ? "#FF8C00" : "#2E7D32", fontWeight: 500 }}>{value}</span>
			)
		}
	]

	return (
		<div>
			<DataGrid
				title={"Lots"}
				columns={columns}
				data={data}
				withFilters={true}
				rowLabel={null}
				withAdditionalFiltersOptions={false}
				tableContainerStyle={{boxShadow: "none"}}
			/>
		</div>
	)
}

export default OrderReceptionLots